// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

/**
 * Detects if the current device is a mobile device where iframe PDF viewing
 * is unreliable (iOS Safari, Android Chrome).
 */
export function isMobileDevice(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;

  const isNarrowScreen = window.matchMedia('(max-width: 767px)').matches;
  const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isMobileUA = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  return isNarrowScreen && (hasTouchScreen || isMobileUA);
}

/**
 * Triggers a browser download from a Blob URL.
 * Creates a temporary anchor element, clicks it, and cleans up.
 */
export function downloadBlobUrl(blobUrl: string, filename: string): void {
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
